import { TextView } from "nystem-components";

const EmailView = (props) => <TextView {...props} />;
export default EmailView;
